import React, {useEffect, useState} from "react";
import {
    albumCountProps,
    albumTimeProps,
    artistCountProps,
    artistTimeProps, TopTableStyleProps,
    trackCountProps,
    trackTimeProps
} from "./top-table-props";
import {TableType, TopItem} from "./types";

const defaultProps = trackCountProps;

interface TopTableProps {
    items: TopItem[],
    type: TableType,
}

interface DropdownProps {
    values: number[],
    initial: number,
}

export const TopTable = (props: TopTableProps) => {
    const [currentHeader, setCurrentHeader] = useState<React.ReactElement>();
    const [currentRow, setCurrentRow] = useState<((item: TopItem) => React.ReactElement)>();
    const [displayedItems, setDisplayedItems] = useState<TopItem[]>([]);
    const [dropdown, setDropdown] = useState<React.ReactElement>();
    const [tableClass, setTableClass] = useState('text-mm-text w-4/5 portrait:w-[95%] mx-auto mb-4 border-collapse');
    const allItems = props.items;

    useEffect(() => {
        const Dropdown = (props: DropdownProps) => {
            const ddValues = props.values;
            const [isOpen, setIsOpen] = useState(false);
            const [currentValue, setCurrentValue] = useState(props.initial);

            // Close the dropdown if the user clicks outside of it
            useEffect(() => {
                document.addEventListener('click', (event) => {
                    const target = event.target as HTMLElement;
                    if (!target.classList.toString().includes('dropdown-stats')) {
                        setIsOpen(false);
                    }
                });
            }, []);

            const toggle = () => {
                setIsOpen(!isOpen);
            }

            const itemClicked = (size: number) => {
                toggle();
                setCurrentValue(size);
                setDisplayedItems(allItems.slice(0, size));
            }

            return (
                <div className={'w-full text-center'}>
                    <div className='dropdown-stats relative inline-block mt-[0.6rem] mx-auto mb-20'>
                        {isOpen && (
                            <div className='dropdown-stats absolute bottom-full right-0 p-2 bg-mm-text shadow-md rounded z-[1]'>
                                <ul className={'list-none p-0 m-0'}>
                                    <li className={'dropdown-stats p-2 cursor-pointer hover:bg-mm-text-hover'} onClick={() => itemClicked(ddValues[0])}>{ddValues[0]}</li>
                                    <li className={'dropdown-stats p-2 cursor-pointer hover:bg-mm-text-hover'} onClick={() => itemClicked(ddValues[1])}>{ddValues[1]}</li>
                                    <li className={'dropdown-stats p-2 cursor-pointer hover:bg-mm-text-hover'} onClick={() => itemClicked(ddValues[2])}>{ddValues[2]}</li>
                                    <li className={'dropdown-stats p-2 cursor-pointer hover:bg-mm-text-hover'} onClick={() => itemClicked(ddValues[3])}>{ddValues[3]}</li>
                                </ul>
                            </div>
                        )}
                        <div className='dropdown-stats flex items-center justify-center p-2 bg-mm-text rounded cursor-pointer w-48' onClick={toggle}>
                            Select table size... {currentValue}
                        </div>
                    </div>
                </div>
            );
        }

        let currentProps: TopTableStyleProps = defaultProps;

        switch (props.type) {
            case TableType.TrackCount:
                currentProps = trackCountProps;
                break;
            case TableType.TrackTime:
                currentProps = trackTimeProps;
                break;
            case TableType.ArtistCount:
                currentProps = artistCountProps;
                break;
            case TableType.ArtistTime:
                currentProps = artistTimeProps;
                break;
            case TableType.AlbumCount:
                currentProps = albumCountProps;
                break;
            case TableType.AlbumTime:
                currentProps = albumTimeProps;
                break;
            default:
                currentProps = defaultProps;
        }
        setDisplayedItems(props.items.slice(0, currentProps.defaultCount));
        setTableClass(currentProps.tableStyle);
        setDropdown(<Dropdown values={currentProps.ddValues} initial={currentProps.defaultCount} />);

        const mediaQuery = window.matchMedia('(orientation: portrait)');
        setCurrentHeader(mediaQuery.matches ? currentProps.head_vert : currentProps.head_horiz);
        setCurrentRow(mediaQuery.matches ? () => currentProps.row_vert : () => currentProps.row_horiz);

        const handleOrientationChange = (event: MediaQueryListEvent) => {
            setCurrentHeader(event.matches ? currentProps.head_vert : currentProps.head_horiz);
            setCurrentRow(event.matches ? () => currentProps.row_vert : () => currentProps.row_horiz);
        }

        mediaQuery.addEventListener('change', handleOrientationChange);
        return () => {
            mediaQuery.removeEventListener('change', handleOrientationChange);
        }
    }, [props, allItems]);

    return (
        <div>
            <table className={tableClass}>
                {currentHeader}
                <tbody>
                    {(displayedItems.length !== 0) && displayedItems.map(currentRow!)}
                </tbody>
            </table>
            {dropdown}
        </div>
    );
}
